export const concatHashtag = tags => {
	return tags.map((tag) => `#${tag}`)
}